(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-slider"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const sliders = document.querySelectorAll('.media-slider');

    sliders.forEach((sliderRoot) => {
      const viewport = sliderRoot.querySelector('.media-slider__viewport');
      const track = sliderRoot.querySelector('.media-slider__track');
      const slides = Array.from(track.children);
      const prevButton = sliderRoot.querySelector('.media-slider__control--prev');
      const nextButton = sliderRoot.querySelector('.media-slider__control--next');
      const dotsContainer = sliderRoot.querySelector('.media-slider__dots');

      if (!slides.length) return;

      let currentIndex = 0;
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function goToSlide(index) {
        const clampedIndex = Math.max(0, Math.min(slides.length - 1, index));
        const offset = clampedIndex * viewport.clientWidth;

        const doScroll = () => {
          viewport.scrollTo({ left: offset, behavior: 'smooth' });
          currentIndex = clampedIndex;
          updateDots();
        };

        if (!prefersReducedMotion && document.startViewTransition) {
          document.startViewTransition(doScroll);
        } else {
          doScroll();
        }
      }

      function createDots() {
        slides.forEach((slide, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'media-slider__dot';
          button.setAttribute('role', 'tab');
          button.setAttribute('aria-label', String(index + 1));
          button.addEventListener('click', () => goToSlide(index));
          dotsContainer.appendChild(button);
        });
        updateDots();
      }

      function updateDots() {
        const dots = Array.from(dotsContainer.children);
        dots.forEach((dot, index) => {
          dot.setAttribute('aria-selected', index === currentIndex ? 'true' : 'false');
        });
      }

      if (prevButton) {
        prevButton.addEventListener('click', () => goToSlide(currentIndex - 1));
      }

      if (nextButton) {
        nextButton.addEventListener('click', () => goToSlide(currentIndex + 1));
      }

      if (viewport) {
        viewport.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            goToSlide(currentIndex + 1);
          } else if (event.key === 'ArrowLeft') {
            event.preventDefault();
            goToSlide(currentIndex - 1);
          }
        });
      }

      window.addEventListener('resize', () => {
        goToSlide(currentIndex);
      });

      createDots();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
